import React from 'react';
import PropTypes from 'prop-types';

// @mui/material components
import Grid from "@mui/material/Grid";

// core components
import StyledLine from "components/List/components/StyledLine";

// local components
import PushErrorDate from "./components/PushErrorDate";
import FeedImport from "./components/FeedImport";
import ValidReferencesCount from "./components/ValidReferencesCount";
import RetailerNameCell from "./components/RetailerNameCell";
import RetailerActionsCell from "./components/RetailerActionsCell";
import RetailerMappingCount from "./components/RetailerMappingCount";
import IncompleteCount from "./components/IncompleteCount";

RetailerItemLine.propTypes = {
    retailer: PropTypes.object,
    del: PropTypes.func,
    createStripe: PropTypes.func,
    authorizations: PropTypes.array,
    stripeLoading: PropTypes.bool,
};

function RetailerItemLine({retailer, del, createStripe, authorizations, stripeLoading}) {

    if (!retailer) {
        return null;
    }

    return (
        <StyledLine
            justifyContent={"space-between"}
            alignItems={"center"}
        >
            <RetailerNameCell retailer={retailer} />
            <Grid
                item
                container
                xs={8}
                columnSpacing={2}
                justifyContent={"flex-end"}
                alignItems={"center"}
                flexWrap={"nowrap"}
            >
                <Grid item sx={{width: '200px'}}>
                    <ValidReferencesCount retailer={retailer} />
                </Grid>
                <Grid item sx={{width: '200px', textAlign: 'center'}}>
                   <RetailerMappingCount
                       productCount={retailer.unmappedProductCount}
                       variationCount={retailer.unmappedVariationCount}
                       retailerId={retailer.id}
                   />
                </Grid>
                <Grid item sx={{width: '200px'}}>
                    <IncompleteCount retailer={retailer} />
                </Grid>
                <Grid item sx={{width: '120px', textAlign: 'center'}}>
                    <FeedImport retailer={retailer} />
                </Grid>
                <Grid item sx={{width: '160px', textAlign: 'center', fontSize: '13px'}}>
                    <PushErrorDate retailer={retailer} />
                </Grid>

                <RetailerActionsCell
                    retailer={retailer}
                    del={del}
                    createStripe={createStripe}
                    authorizations={authorizations}
                    stripeLoading={stripeLoading}
                />
            </Grid>
        </StyledLine>
    );
}

export default RetailerItemLine;
